import { ChevronsDown } from '@deepup/icons';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
  TextField,
  Checkbox,
} from '@mui/material';
import React from 'react';

interface RemarksProps {
  remarks: string;
  setRemarks: (remarks: string) => void;
  shouldShowWarning: boolean;
  shouldDeleteAllRemarks: boolean;
  setShouldDeleteAllRemarks: (shouldDeleteAllRemarks: boolean) => void;
  disabled?: boolean;
}

export const Remarks = ({
  remarks,
  setRemarks,
  shouldShowWarning,
  shouldDeleteAllRemarks,
  setShouldDeleteAllRemarks,
  disabled,
}: RemarksProps) => {
  return (
    <Accordion disableGutters square elevation={12}>
      <AccordionSummary expandIcon={<ChevronsDown fontSize={24} />}>
        <Typography variant="body1">Leave a comment</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {shouldShowWarning && (
          <Typography variant="body2" mb={1}>
            Warning: Multiple scans selected! This will override the remarks for all selected scans.
          </Typography>
        )}
        <Stack gap={1} mx={-0.5}>
          <TextField
            fullWidth
            multiline
            rows={3}
            placeholder="Add here a comment for your Co-Workers in a multiline textfield..."
            size="small"
            sx={{ mx: 0.5 }}
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
            disabled={shouldDeleteAllRemarks || disabled}
          />
        </Stack>
        {shouldShowWarning && (
          <Stack direction="row" alignItems="center" gap={1}>
            <Checkbox
              checked={shouldDeleteAllRemarks}
              disabled={disabled}
              onChange={(event) => setShouldDeleteAllRemarks(event.target.checked)}
              title="Delete remarks for all selected scans"
              inputProps={{ 'aria-label': 'Delete remarks for all selected scans' }}
            />
            <Typography variant="body2">Delete remarks for all selected scans</Typography>
          </Stack>
        )}
      </AccordionDetails>
    </Accordion>
  );
};
